"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDefaultCenter = exports.googleMarkers = exports.selectSvgPoints = exports.selectSvgLines = exports.setMarkers = exports.emptyLinesAndPoints = exports.contactLastToFirst = exports.createExistLines = exports.addLine = exports.getMapPostsResultByViewBox = exports.getSearchCoordinates = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var GoogleGeocoding_1 = __importDefault(require("../../constants/GoogleGeocoding"));
var searchResultSlice_1 = require("../SearchResult/searchResultSlice");
var initialState = {
    lines: [],
    points: [],
    defaultCenter: GoogleGeocoding_1.default.MAP.DEFAULT_CENTER,
    markers: [],
};
var googleReducer = toolkit_1.createSlice({
    name: 'map',
    initialState: initialState,
    reducers: {
        addLine: function (state, action) {
            state.lines = __spreadArray(__spreadArray([], state.lines), [action.payload]);
        },
        contactLastToFirst: function (state) {
            state.lines.push(state.lines[0]);
        },
        emptyLinesAndPoints: function (state) {
            state.points = [];
            state.lines = [];
        },
        createExistLines: function (state) {
            if (state.lines.length > 0) {
                state.points.push(state.lines);
                state.lines = [];
            }
        },
        setMarkers: function (state, action) {
            state.markers = action.payload;
        },
    },
});
var getSearchCoordinates = function (filters, viewBox, customViewBox, multiPolygon, page) {
    if (page === void 0) { page = 1; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var params, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        viewBox: viewBox,
                        multiPolygon: multiPolygon,
                        customViewBox: customViewBox,
                        filters: filters,
                    };
                    if (multiPolygon) {
                        params.customViewBox = customViewBox[0].map(function (item) { return [
                            item,
                        ]; });
                    }
                    return [4 /*yield*/, axios_1.default.post("/api/search/location?page=" + page, {
                            params: params,
                        })];
                case 1:
                    data = (_a.sent()).data.data;
                    // Dispatch to searchResult reducer
                    dispatch(searchResultSlice_1.getSearchResultSuccess(data.posts));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getSearchCoordinates = getSearchCoordinates;
var getMapPostsResultByViewBox = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var params, data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        viewBox: payload.viewBox,
                        filters: payload.filters,
                        limit: -1,
                    };
                    return [4 /*yield*/, axios_1.default.post("/api/search/markers", {
                            params: params,
                        })];
                case 1:
                    data = (_a.sent()).data.data;
                    dispatch(exports.setMarkers(data.posts.data));
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMapPostsResultByViewBox = getMapPostsResultByViewBox;
exports.addLine = (_a = googleReducer.actions, _a.addLine), exports.createExistLines = _a.createExistLines, exports.contactLastToFirst = _a.contactLastToFirst, exports.emptyLinesAndPoints = _a.emptyLinesAndPoints, exports.setMarkers = _a.setMarkers;
var selectSvgLines = function (state) { return state.map.lines; };
exports.selectSvgLines = selectSvgLines;
var selectSvgPoints = function (state) { return state.map.points; };
exports.selectSvgPoints = selectSvgPoints;
var googleMarkers = function (state) { return state.map.markers; };
exports.googleMarkers = googleMarkers;
var selectDefaultCenter = function (state) {
    return state.map.defaultCenter;
};
exports.selectDefaultCenter = selectDefaultCenter;
exports.default = googleReducer.reducer;
